export const getMonthName = (dateString) => {
  if (!dateString) {
    console.warn('Date manquante');
    return 'Date non disponible';
  }

  // Convertir la date au format DD/MM/YYYY en YYYY-MM-DD
  const dateParts = dateString.split('/');
  if (dateParts.length === 3) {
    const [day, month, year] = dateParts;
    const formattedDate = `${year}/${month}/${day}`; // Format YYYY-MM-DD
    const date = new Date(formattedDate);
    if (isNaN(date.getTime())) {
      console.error('Date invalide:', dateString);
      return 'Date invalide';
    }
    const monthNames = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    return monthNames[date.getMonth()];
  } else {
    console.error('Format de date invalide:', dateString);
    return 'Date invalide';
  }
};

export const formatDateToDDMMYYYY = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}; 